export default "__VITE_ASSET__MZqK2Lt1__"